@use '~/theme/theme' as *;
@use '~/theme/typography';

.indicatorContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  margin-top: 1px;
  width: 20px;
  height: 20px;
  transition:
    background-color 250ms,
    color 250ms,
    border-color 250ms,
    outline-offset 250ms,
    outline-width 250ms;
}

.indicator {
  border: 2px var(--indicator-color) solid;
  border-radius: 10px;
  color: white;
  background: var(--indicator-background);
  display: flex;
  align-items: center;
  width: 20px;
  height: 20px;
  z-index: 1;
  flex-shrink: 0;
  transition:
    border-width 250ms,
    color 250ms,
    outline-color 250ms,
    width 250ms,
    height 250ms;
}

.control {
  --indicator-color: #{color(grey-800)};
  --indicator-background: white;
  --hover-color: #{color(violet-200)};
  --label-color: #{color(grey-800)};

  @include typography.body2;
  @include typography.regular;

  display: flex;
  align-items: center;
  align-self: flex-start;
  gap: spacing(1);
  cursor: pointer;
  color: var(--label-color);

  &[data-focus-visible] .indicator {
    outline: 2px solid color(violet-600);
    outline-offset: 2px;
  }

  &[data-hovered] .indicatorContainer {
    background: var(--hover-color);
    outline: 4px solid var(--hover-color);
  }

  &[data-selected] {
    .indicator {
      border: none;
      border: 5px var(--indicator-color) solid;
    }

    .icon {
      display: block;
    }
  }

  &[data-invalid] {
    --indicator-color: #{color(lobster-800)};
    --hover-color: #{color(lobster-200)};
  }

  &[data-disabled] {
    --indicator-color: #{color(grey-500)};
    --label-color: #{color(grey-500)};
    --indicator-background: #{color(grey-200)};

    cursor: unset;

    &[data-invalid] {
      --indicator-background: #{color(lobster-200)};
    }
  }
}

.withOtherInfo {
  flex-wrap: wrap;
  align-items: flex-start;
}

.otherInfo {
  width: 100%;
}

.strong {
  @include typography.semibold;
}

.invalid {
  --indicator-color: #{color(lobster-800)};
  --hover-color: #{color(lobster-200)};
}
